var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo"},[_c('div',{staticClass:"bgBlueF3 px-38 pb-30 mb-30"},[_c('p',[_vm._v("暂无")])])])
}]

export { render, staticRenderFns }